export const environment = {
  production: false,
  firebase:{
    apiKey: "AIzaSyCUCrBOTlCb_tsSGB525J5d8u32c6PwEs0",
    authDomain: "noviembre-seis.firebaseapp.com",
    projectId: "noviembre-seis",
    storageBucket: "noviembre-seis.appspot.com",
    messagingSenderId: "520811229074",
    appId: "1:520811229074:web:5ed23f37dd40fee0e21b4b"
  }
};
